import Component from 'antd/es/dropdown';
import 'antd/lib/dropdown/style';
export default Component;
